import React from "react";
import { InputContainer } from "../../Form";
import { Input } from "./TextArea.styled";

export const TextArea = ({
  id,
  label,
  value,
  onChange,
  maxLength = 200,
  minRows = 2,
  placeholder = "",
  isRequired = false,
  flex = "1 0 auto",
  width
}) => {
  return (
    <InputContainer
      id={id}
      label={label}
      maxLen={maxLength}
      textLen={value?.length}
      isRequired={isRequired}
      flex={flex}
      width={width}
      render={(ID) => (
        <Input
          id={ID}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          minRows={minRows}
          maxLength={maxLength}
        />
      )}
    />
  );
};
